import { TRANSLATIONS_FETCH_TRANSLATE_LIST } from "@/modules/translations/store/mutations-type"

const mutations = {
  [TRANSLATIONS_FETCH_TRANSLATE_LIST](state, payload) {
    state.translationsList = payload
  },
}
export default mutations
